<template lang="pug">
div
  h2.pb-4 Рекомендации наставника:
  server-data(
    ref="recommendationList"
    :method="$api.mentoring.getPracticeForUser"
    :query="query"
    v-slot="{ serverData, loading }"
  )
    data-wrapper(
      :loading="loading"
      :skeleton-items-count="4"
      :has-items="!!serverData.length"
      skeleton-type="paragraph"
      :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
    )
      template(#no-data)
        v-alert(type="info" prominent text) Еще нет рекомендаций
      template(#default)
        v-list
          v-list-item.sdo-radius(
            v-for="item in serverData" :key="item.id"
            :to="{ name: 'ResourceDetail', params: { id: item.id } }"
          )
            v-list-item-content
              v-list-item-title: h3.grey--text.text--darken-2 {{ item.title }}
              .text-caption {{ item.description }}
              .text-caption.primary--text: strong от {{ item.created_at | dp('d MMMM y') }}
            v-list-item-action
              v-icon(color="primary") mdi-arrow-right

</template>
<script>
import DataWrapper from '@/components/DataWrapper.vue';

export default {
  components: {
    DataWrapper,
  },
  data() {
    return {
      query: {
      },
    };
  },
};
</script>
